/* eslint-disable camelcase */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Payment.scss";
import { addCreditCardRequest } from "../../../../../api/ehrconnect";
import { togglePopupLoader } from "../../../../../redux/actions/configurationActions";
import { StringIsNumber } from "../../../../../legacy/utils/helpers";
import { AddCardStatus } from "src/latest/src/constants/AddCardStatus";

declare let Heartland: any;

const Payment = ({ choice, onToken }: any) => {
    const { initialMetadata,currentConfig } = useSelector(
        (state: any) => state?.questionnaireData
    );
    const { user_id } = initialMetadata;
    const dispatch = useDispatch();
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const currentQuestion = currentConfig?.currentQuestions?.filter((q:any)=>q.unique_key === "creditCardForSelfMatchingClientQuestionV1")[0];
    const creditCardCaptureKey = currentQuestion.metadata.credit_card_capture_key;

    useEffect(() => {
        // Create a new `HPS` object with the necessary configuration
        const hps: any = new Heartland.HPS({
            publicKey:
              creditCardCaptureKey,
            type: "iframe",
            // Configure the iframe fields to tell the library where
            // the iframe should be inserted into the DOM and some
            // basic options

            fields: {
                cardNumber: {
                    target: "iframesCardNumber",
                    placeholder: "•••• •••• •••• ••••",
                },
                zip: {
                    selector: "iframeszipCode",
                    placeholder: "Zip Code",
                    maxLength: 6,
                },
                cardholderName: {
                    selector: "iframescardholderName",
                    placeholder: "Cardholder Name",
                },
                cardExpiration: {
                    target: "iframesCardExpiration",
                    placeholder: "MM / YYYY",
                },
                cardCvv: {
                    target: "iframesCardCvv",
                    placeholder: "***",
                    maskInput: true,
                    maskCharacter: "*",
                    maskPattern: "999",
                    maxLength: 3,
                },

                submit: {
                    value: "Add Card",
                    target: "iframesSubmit",
                    disabled: true,
                    className: "submitBtn",
                    class: "SubmitBtn",
                },
            },

            // Collection of CSS to inject into the iframes.
            // These properties can match the site's styles
            // to create a seamless experience.
            style: {
                input: {
                    background: "#fff",
                    border: "1px solid",
                    "border-color": "#bbb3b9 #c7c1c6 #c7c1c6",
                    "box-sizing": "border-box",
                    "font-family": "serif",
                    "font-size": "16px",
                    "line-height": "1",
                    margin: "0 .5em 0 0",
                    "max-width": "100%",
                    outline: "0",
                    padding: "0.5278em",
                    "vertical-align": "baseline",
                    height: "50px",
                    width: "100% !important",
                },
                "#heartland-field": {
                    "font-family": "sans-serif",
                    "box-sizing": "border-box",
                    display: "block",
                    height: "50px",
                    padding: "6px 12px",
                    "font-size": "14px",
                    "line-height": "1.42857143",
                    color: "#555",
                    "background-color": "#fff",
                    border: "1px solid #ccc",
                    "border-radius": "0px",
                    "-webkit-box-shadow": "inset 0 1px 1px rgba(0,0,0,.075)",
                    "box-shadow": "inset 0 1px 1px rgba(0,0,0,.075)",
                    "-webkit-transition":
                        "border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s",
                    "-o-transition":
                        "border-color ease-in-out .15s,box-shadow ease-in-out .15s",
                    transition:
                        "border-color ease-in-out .15s,box-shadow ease-in-out .15s",
                    width: "100%",
                },
                "#heartland-field[name=submit]": {
                    "background-image":
                        "linear-gradient(to right, #0fcc93 0%, #26ecb0 51%, #0fcc93 100%)",
                    color: "#fcfcfc",
                    border: "0px solid transparent",
                    "font-weight": "700",
                    "font-size": "14px",
                    "border-radius": "6px",
                },
                "#heartland-field[name=submit]:focus": {
                    color: "#ffffff",
                    "background-color": "#258851",
                    outline: "none",
                },
                "#heartland-field[name=submit]:hover": {
                    "background-color": "#258851",
                },
                "#heartland-field-wrapper #heartland-field:focus": {
                    border: "1px solid #3989e3",
                    outline: "none",
                    "box-shadow": "none",
                    height: "50px",
                },
                "heartland-field-wrapper #heartland-field": {
                    height: "50px",
                },
                "input[type=submit]": {
                    "box-sizing": "border-box",
                    display: "inline-block",
                    padding: "6px 12px",
                    "margin-bottom": "0",
                    "font-size": "14px",
                    "font-weight": "900",
                    "line-height": "1.42857143",
                    "text-align": "center",
                    "white-space": "nowrap",
                    "vertical-align": "middle",
                    "-ms-touch-action": "manipulation",
                    "touch-action": "manipulation",
                    cursor: "pointer",
                    "-webkit-user-select": "none",
                    "-moz-user-select": "none",
                    "-ms-user-select": "none",
                    "user-select": "none",
                    "background-image": "none",
                    border: "1px solid transparent",
                    "border-radius": "4px",
                    color: "#fff",
                    "background-color": "#337ab7",
                    "border-color": "#2e6da4",
                },
                "#heartland-field[placeholder]": {
                    "letter-spacing": "3px",
                },
                "#heartland-field[name=cardCvv]": {
                    background:
                        "transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/cvv1.png?raw=true) no-repeat right",
                    "background-size": "63px 40px",
                    "-webkit-text-security": "disc",
                },
                "#heartland-field[name=cardholderName]": {
                    background:
                        "transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/cvv1.png?raw=true) no-repeat right",
                    "background-size": "63px 40px",
                },
                "#heartland-field[name=zipCode]": {
                    background:
                        "transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/cvv1.png?raw=true) no-repeat right",
                    "background-size": "63px 40px",
                },
                "input#heartland-field[name=cardNumber]": {
                    background:
                        "transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-inputcard-blank@2x.png?raw=true) no-repeat right",
                    "background-size": "55px 35px",
                },
                "#heartland-field.invalid.card-type-visa": {
                    background:
                        "transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right",
                    "background-size": "83px 88px",
                    "background-position-y": "-44px",
                },
                "#heartland-field.valid.card-type-visa": {
                    background:
                        "transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right top",
                    "background-size": "82px 86px",
                },
                "#heartland-field.invalid.card-type-discover": {
                    background:
                        "transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right",
                    "background-size": "85px 90px",
                    "background-position-y": "-44px",
                },
                "#heartland-field.valid.card-type-discover": {
                    background:
                        "transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right",
                    "background-size": "85px 90px",
                    "background-position-y": "1px",
                },
                "#heartland-field.invalid.card-type-amex": {
                    background:
                        "transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right",
                    "background-size": "50px 90px",
                    "background-position-y": "-44px",
                },
                "#heartland-field.valid.card-type-amex": {
                    background:
                        "transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right top",
                    "background-size": "50px 90px",
                },
                "#heartland-field.invalid.card-type-mastercard": {
                    background:
                        "transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right",
                    "background-size": "62px 105px",
                    "background-position-y": "-52px",
                },
                "#heartland-field.valid.card-type-mastercard": {
                    background:
                        "transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right",
                    "background-size": "62px 105px",
                    "background-position-y": "-1px",
                },
                "#heartland-field.invalid.card-type-jcb": {
                    background:
                        "transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right",
                    "background-size": "55px 94px",
                    "background-position-y": "-44px",
                },
                "#heartland-field.valid.card-type-jcb": {
                    background:
                        "transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right top",
                    "background-size": "55px 94px",
                    "background-position-y": "2px",
                },
                "input#heartland-field[name=cardNumber]::-ms-clear": {
                    display: "none",
                },
            },

            // Callback when a token is received from the service
            onTokenSuccess: async (resp: any) => {
                const zipValue: any = document.getElementById(
                    "paymentGatewayZipCode"
                );

                if (zipValue?.value.length > 5) {
                    setError("Zipcode should not be more than 5 digits");
                    dispatch(togglePopupLoader(false));

                    return;
                }

                if (!StringIsNumber(zipValue?.value)) {
                    setError("Zipcode should only contain numbers");
                    dispatch(togglePopupLoader(false));

                    return;
                }

                try {
                    const data = {
                        card_expiry_month: resp?.exp_month?.trim(),
                        card_expiry_year: resp?.exp_year?.trim(),
                        card_holder_name: "Visa",
                        card_last_4_digit: resp?.last_four?.trim(),
                        credit_card_token: resp?.token_value?.trim(),
                        user_id,
                        zipcode: zipValue?.value,
                    };

                    // Check if all required fields are filled
                    if (
                        !data.card_expiry_month ||
                        !data.card_expiry_year ||
                        !data.card_last_4_digit ||
                        !data.credit_card_token ||
                        !data.user_id ||
                        !data.zipcode
                    ) {
                        setError("Please fill in all card details.");
                        dispatch(togglePopupLoader(false));

                        return;
                    }

                    await addCreditCardRequest(data);
                    onToken(AddCardStatus.SUCCESS, choice);
                    dispatch(togglePopupLoader(false));
                    setMessage("Card successfully added");

                    // Empty the values
                    data.zipcode = "";
                } catch (error) {
                    onToken(AddCardStatus.ERROR, choice);
                    dispatch(togglePopupLoader(false));
                    // Show error message here
                    setError(
                        "Error entering credit card. Please continue and you can provide your payment info by phone."
                    );

                    console.error(error);
                }
            },
            // Callback when an error is received from the service
            onTokenError: (resp: any) => {
                onToken(AddCardStatus.ERROR, choice);
                setError(resp.error.message);
                dispatch(togglePopupLoader(false));
            },
            // Callback when an event is fired within an iFrame
            onEvent: (ev: any) => {
                if (ev.source === "submit" && ev.type === "click") {
                    dispatch(togglePopupLoader(true));
                    setError("");
                    setMessage("");
                }
            },
        });

        return () => {
            hps?.dispose();
        };
    }, []);

    return (
        <div className="form-wrapper payment-page">
            <form id="iframes" action="" method="GET">
                <div id="ss-banner" />

                <div className="form-row">
                    <label htmlFor="iframesCardNumber">Card Number:</label>
                    <div id="iframesCardNumber" />
                </div>
                <div className="form-row">
                    <label htmlFor="iframesCardExpiration">
                        Card Expiration:
                    </label>
                    <div id="iframesCardExpiration" />
                </div>

                <div className="form-row">
                    <label htmlFor="iframesCardCvv">Card CVV:</label>
                    <div id="iframesCardCvv" />
                </div>
                <div className="form-row">
                    <label htmlFor="iframesCardNumber">Zip code:</label>
                    <input
                        type="string"
                        placeholder="Zip code"
                        className="zipCode"
                        id="paymentGatewayZipCode"
                        min="0"
                        max="6"
                    />
                </div>

                <br />

                <div id="iframesSubmit" className="submitBtn" />
            </form>
            {error !== "" && error ? (
                <h3
                    style={{
                        width: "320px",
                        margin: "auto",
                        color: "#DC1A1A",
                        height: "42px",
                        textAlign: "center",
                        fontSize: "14px",
                        fontFamily: "Source Sans Pro",
                        fontWeight: "600",
                    }}
                >
                    {error}
                </h3>
            ) : (
                <h3
                    style={{
                        width: "300px",
                        margin: "auto",
                        color: "#1bdca2",
                        height: "42px",
                        textAlign: "center",
                        fontSize: "14px",
                        fontFamily: "Source Sans Pro",
                        fontWeight: "600",
                    }}
                >
                    {message}
                </h3>
            )}
        </div>
    );
};

export default Payment;
